import * as React from "react";
import ContentHeaderHint from "./subtitle";
import ContentHeaderTitle from "./title";
import { ContentHeaderProps } from "./types";

export default function ContentHeader({
  title,
  subtitle,
}: ContentHeaderProps): React.JSX.Element {
  return (
    <>
      <ContentHeaderTitle title={title} />
      <ContentHeaderHint title={subtitle} />
    </>
  );
}
